const ErrorHandler = ({error}) => {
    return (
        <td>{error.message}</td>
    )
}

export default function DeliveredDate({d}) {
  try {
      // Parse the input date string into a JavaScript Date object
      const date = new Date(d);
  
      // Use Intl.DateTimeFormat to convert to Central Time
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Chicago", // Central Time Zone
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
  
      // Format the date
      const formattedDate = formatter.format(date);
  
      return <td>{formattedDate}</td>;
    } catch (error) {
      return <ErrorHandler error={error} />;
    }
}